import { ProgramContainer } from "../../entities/formTemplateDataType";
import DataUtils from "../DataUtils";

export default class OerUtils {
	static retrieveFormData = (programContainer: ProgramContainer, data: any) => {
		programContainer.Entity = data;
		DataUtils.assignFormValue(programContainer);
	}
}
